/* 🤖 this file was generated by svg-to-ts */
export const emperorIconCheckBox: {
  name: 'check_box';
  data: string;
} = {
  name: 'check_box',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><g><path d="M18.04 22h-14c-1.11 0-2-.9-2-2V8c0-1.11.89-2 2-2h10v2h-10v12h14v-5h2v5c0 1.1-.9 2-2 2Z"/><path d="M11.084 17.81L6.15 12.88l1.76-1.77 3.07 3.074 9.11-10.04 1.84 1.68Z"/></g></svg>`
};
